//
// Search Button(JS)
// 2019-02-11
// Space-Time Inc.
//

function searchButtonToggle(){
	var field = document.getElementById("search-field");
		field.classList.toggle("visible")
}
